export const FETCH_TRIAL_PROMO_INFO = 'trialPromo/FETCH_TRIAL_PROMO_INFO'
export const FETCH_TRIAL_PROMO_INFO_SUCCESS = 'trialPromo/FETCH_TRIAL_PROMO_INFO_SUCCESS'
export const FETCH_TRIAL_PROMO_INFO_FAILED = 'trialPromo/FETCH_TRIAL_PROMO_INFO_FAILED'
export const EXPIRE_TRIAL_PROMO_INFO = 'trialPromo/EXPIRE_TRIAL_PROMO_INFO'
